import classcat from "classcat";
import React from "react";

import { Button, ConfirmationModal } from "@touchtech/web-baselayer-ui";

import { CollectionListItem } from "@is/types";

import Collection from "./Collection";
import css from "./StoreFavoritesModal.module.css";
import useManageStoreFavoritesModal from "./hooks/useManageStoreFavoritesModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const StoreFavoritesModal = ({ isOpen, onClose }: Props) => {
  const { t, collectionItems, handleCollectionClick } =
    useManageStoreFavoritesModal({ onClose });

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Store favorites")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {t("Select a collection to open")}
        </span>
        <div className={css.collectionsContainer}>
          {collectionItems?.map((collection: CollectionListItem) => (
            <Collection
              key={collection.id}
              collection={collection}
              onCollectionClick={handleCollectionClick}
            />
          ))}
        </div>
        <Button
          className={css.closeButton}
          width="full"
          sizing="lg"
          onClick={onClose}
        >
          {t("Close")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default StoreFavoritesModal;
